import xor from 'lodash/xor';

import {
  RESET_STUDENT_ASSIGNMENTS,
  SELECT_ALL_ASSIGNMENTS,
  STUDENT_ASSIGNMENTS_ERROR,
  STUDENT_ASSIGNMENTS_REQUEST,
  STUDENT_ASSIGNMENTS_SUCCESS,
  TOGGLE_SELECTED_ASSIGNMENT_IDS,
  UNSELECT_ALL_ASSIGNMENTS,
  UPDATE_SORT_DIRECTION_TO_ASC,
  UPDATE_SORT_DIRECTION_TO_DESC
} from './actions';

const initialState = {
  assignments: [],
  loading: false,
  selectedAssignmentIds: [],
  sortDirection: 'asc'
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case STUDENT_ASSIGNMENTS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case STUDENT_ASSIGNMENTS_SUCCESS:
      return {
        ...state,
        assignments: action.assignments,
        loading: false
      };
    case STUDENT_ASSIGNMENTS_ERROR:
      return {
        ...state,
        assignments: [],
        loading: false
      };
    case RESET_STUDENT_ASSIGNMENTS:
      return {
        ...state,
        assignments: []
      };
    case UPDATE_SORT_DIRECTION_TO_ASC:
      return {
        ...state,
        sortDirection: 'asc'
      };
    case UPDATE_SORT_DIRECTION_TO_DESC:
      return {
        ...state,
        sortDirection: 'desc'
      };
    case UNSELECT_ALL_ASSIGNMENTS:
      return {
        ...state,
        selectedAssignmentIds: []
      };
    case SELECT_ALL_ASSIGNMENTS:
      return {
        ...state,
        selectedAssignmentIds: state.assignments.map(a => a.assignmentId)
      };
    case TOGGLE_SELECTED_ASSIGNMENT_IDS:
      return {
        ...state,
        selectedAssignmentIds: xor([...state.selectedAssignmentIds], [action.assignmentId])
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./components/current-assignment-modal/redux/reducer.js